import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IncidentTypeService } from '../services/incident-type.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IonModal, LoadingController } from '@ionic/angular';

@Component({
    selector: 'app-config-incident-type',
    templateUrl: './config-incident-type.component.html',
    styleUrls: ['./config-incident-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfigIncidentTypeComponent implements OnInit {

  incidentTypeObservable: any;
  incidentType: any;
  incidentModel: any;
  availableForms: any;
  id: any;

  @ViewChild(IonModal) modal!: IonModal;
  
  tempForm = '';
  name = '';
  multiple = false;
  external = false;
  description = '';
  dirty = true;
  dateFormat = "MM/dd/yyyy h:mm a";

  constructor(public incidentTypeService: IncidentTypeService, private router: Router, private route: ActivatedRoute, private loadingCtrl: LoadingController) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.incidentTypeObservable = this.incidentTypeService.getIncidentTypeAndModel(this.id);
    this.availableForms = this.incidentTypeService.getForms();
    this.incidentTypeObservable.subscribe((result: any) => {
      console.log("returned");
      this.incidentType = result[0];
      this.incidentModel = result[1];
    });

    this.dateFormat = this.incidentTypeService.dateFormat;

  }

  saveForm() {

    this.showLoading();
    this.incidentTypeService.updateIncidentModel(this.id, this.incidentModel._id, this.incidentModel).subscribe((result: any) => {
      this.dirty = false;
      this.dismissLoading();
    });
  }

  editWorkflow() {
    this.router.navigate(['/incident-type/' + this.id + '/workflow/']);
  }

  remove(formId: any) {
    console.log(formId);
    for (let i = 0; i < this.incidentModel.incidentForms.length; i++) {
      if (this.incidentModel.incidentForms[i]._id === formId) {
        this.incidentModel.incidentForms.splice(i, 1);
        break;
      }
    }
  }

  onWillDismiss(event: any) {

  }

  toggleVisible(formId: any) {
    console.log(this.incidentModel.incidentForms.find((x: any) => x._id === formId));
    console.log(formId);
    if (this.incidentModel.incidentForms.find((x: any) => x._id === formId).hidden === undefined) {
      this.incidentModel.incidentForms.find((x: any) => x._id === formId).hidden = false;
    }

    console.log(this.incidentModel.incidentForms.find((x: any) => x._id === formId).hidden);
    this.incidentModel.incidentForms.find((x: any) => x._id === formId).hidden = !this.incidentModel.incidentForms.find((x: any) => x._id === formId).hidden;

  }

  cancel() {

    this.tempForm = '';
    this.multiple = false;
    this.external = false;
    this.description = '';
    this.name = '';
    this.modal.dismiss(null, 'cancel');
  }

  confirm() {

    this.availableForms.subscribe((result: any) => {
      this.dirty = true;
      let formModel = result.find((x: any) => x._id === this.tempForm);
      for (let element of formModel.formElements) { //replace after migrating to new form schema
        console.log(element.columns);
        element.name = element.fieldName;
        element.label = element.fieldLabel;
        element.identityString = element.id;
        element.type = element.fieldType;
        element.value = element.fieldValue;

        if(!element.config){
          element.config = { options: element.selectValues
          };
        }
        if(!element.children || element.children.length < 1){

          if(element.childTemplate && element.childTemplate.length > 0){

            for(let child of element.childTemplate){
              child.name = child.fieldName;
              child.label = child.fieldLabel;
              child.identityString = child.id;
              child.type = child.fieldType;
              child.value = child.fieldValue;
              if(!child.config){
                child.config = { options: child.selectValues
                };
              }
            }
          }else{
            element.children = element.columns;
          }

          if (element.children && element.children.length > 0) {
            for (let childElement of element.children) {
              childElement.name = childElement.fieldName;
              childElement.label = childElement.fieldLabel;
              childElement.type = childElement.fieldType;
              childElement.identityString = childElement.id;
              if(!childElement.config){
                childElement.config = { options: childElement.selectValues };
              }
              if(!childElement.children){
                childElement.children = childElement.columns;
              }
              childElement.value = childElement.fieldValue;
              if (childElement.children && childElement.children.length > 0) {
                for (let subchildElement of childElement.children) {
                  subchildElement.name = subchildElement.fieldName;
                  subchildElement.label = subchildElement.fieldLabel;
                  subchildElement.type = subchildElement.fieldType;
                  subchildElement.identityString = subchildElement.id;
                  if(!subchildElement.config){
                    subchildElement.config = { options: subchildElement.selectValues };
                  }
                  if(!subchildElement.children){
                    subchildElement.children = subchildElement.columns;
                  }
                  subchildElement.value = subchildElement.fieldValue;
                }
              }
            }
          }
        }else{
          console.log(element.children);
          if(element.children && element.children.length > 0){
            for(let childElement of element.children[0]){
              childElement.name = childElement.fieldName;
              childElement.label = childElement.fieldLabel;
              childElement.type = childElement.fieldType;
              childElement.identityString = childElement.id;
            }
          }
        }
      }

      let form = {
        name: this.name || formModel.formName,
        hidden: false,
        identityString: formModel._id,
        acceptsMultipleSubmissions: this.multiple,
        acceptsExternalSubmissions: this.external,
        description: this.description,
        elements: formModel.formElements,
        entries: [{ elementTree: formModel.formElements }] //start with 1 default entry
      };
      this.incidentModel.incidentForms.push(form);

    });
    this.modal.dismiss(null, 'confirm');
  }

  async showLoading() {
    const loading = await this.loadingCtrl.create({
    });

    loading.present();
  }

  dismissLoading() {
    let that = this;
    setTimeout(function () {
      that.loadingCtrl.dismiss();
    }, 400);

  }

}
